// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneCategoryTranslationFragmentDoc } from './StoneCategoryTranslation.fragment.generated';
export const StoneCategoryFragmentDoc = `
    fragment stoneCategory on StoneCategory {
  systemCode
  translation(locale: $locale) {
    ...stoneCategoryTranslation
  }
}
    `;